import type { BenefitsHintProps } from './interfaces';
import styles from './BenefitsHint.module.scss';

const BenefitsHint = ({ children }: BenefitsHintProps) => {
  return (
    <div className={styles.base}>
      <span className={styles.text}>{children}</span>
    </div>
  );
};

export default BenefitsHint;
